<template>
  <section class="agreement-con" :class="!isMobile ? 'pc-agreement-con' : '' ">
    <div
      id="agreementContent"
      class="layout-agreement"
      ref="agreementContent"
      :class="!isMobile ? 'pc-layout-agreement' : '' "
    >
      <h1 class="agreement-title">{{ data.title }}</h1>
      <div class="date" v-if="['provider', 'supplier'].includes(type)">更新日期：2023年5月11日</div>
      <div class="date" style="padding-bottom:10px;" v-if="['provider', 'supplier'].includes(type)">生效日期：2023年5月11日</div>
      <p class="agreement-item" v-for="(item, index) in data.content" :key="index">
        {{ item }}
      </p>
    </div>
    <div
      class="agreement-footer"
      v-if="isShowSubmit"
      :class="!isMobile ? 'pc-agreement-footer' : '' "
    >
      <button
        class="agreement-btn"
        :class="!isMobile ? 'pc-agreement-btn' : '' "
        @click="submit"
        :disabled="submitCount > 0"
      >
        同意协议<template v-if="submitCount">（{{submitCount}}s）</template>
      </button>
    </div>
  </section>
</template>

<script>
import wx from 'weixin-js-sdk';

export default {
  name: 'BaibuRegistrationAgreement',
  data() {
    return {
      isShowSubmit: true,
      submitCount: 5,
      submitTimeout: null,
      data: {
        title: '',
        contetn: [],
      },
      // 供应商
      supplier: {
        title: '百布平台供应商用户协议',
        content: [
          '百布平台供应商用户协议（以下简称“本协议”）是您（或称“用户”、“供应商”）与百布（以下简称为“本平台”）所有者广州百景信息科技服务有限公司（以下简称为“百景公司”）之间就本平台服务等相关事宜所订立的协议，请您仔细阅读本协议，特别是涉及免除或责任限制的条款，该等条款可能以加粗的形式提示您注意，您勾选“同意”按钮后，本协议即构成对双方有约束力的法律文件。',
          '第1条.本平台服务条款的确认和接纳',
          '1.1本平台的各项在线服务的所有权和运作权归百景公司所有。您同意本协议所有条款并完成注册程序，才能成为本平台的正式供应商用户。您确认：本协议条款是处理双方权利义务的协议，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。',
          '1.2您点击同意本协议，即视为您确认自己有完全的民事行为能力进行在线发布销售服装面料、辅料信息及享受本平台提供的其他服务，对此您能够独立承担法律责任。',
          '1.3百景公司保留在中华人民共和国大陆地区适用之法律允许的范围内独自决定拒绝服务、关闭您账户、清除或编辑内容或取消订单的权利。',
          '1.4本平台对本协议条款保留最终解释权，并有权在法律允许的范围内对协议条款进行更新，且无须另行通知。修改后的协议条款一旦在本平台上公布即有效并代替原来的协议条款。您选择继续接受本平台提供的服务，则视为您已经接受本协议更新和修改的内容。',
          '第2条.本平台的服务',
          '2.1本平台为信息服务平台，为采购商及供应商提供需求及产品的信息展示服务，并为服务商提供产品需求智能识别技术及交易信息线索，提高服务商的交易撮合成功率。具体为：采购商可以通过本平台即时发布及确认其对于服装面料、辅料的采购需求，平台根据自主研发的色谱识别系统智能筛选对应色卡，并结合百景公司提供的线下匹配服务，明确采购商的最终订单需求；服务商有权通过本平台为采购商及供应商提供销售交易促成服务，即接收采购商的最终订单需求，将该等需求报告给供应商。同时，服务商有权依据供应商通过本平台勾选的服务类型为其提供相应的服务，包括但不限于本协议第17条约定的产品质量检验服务、保管及物流配送服务、信息上传服务等，最终由供应商按照订单需求完成产品的准备、交付等工作。 ',
          '2.2您在完全同意本协议及遵循本平台相关规定的情况下，有权使用本平台的相关服务。本平台所提供的服务不应视为对您和其他相关方本身、交易本身以及其他相关行为提供任何形式的承诺、保证或担保。',
          '第3条.用户信息',
          '3.1您应本着个人或企业诚信向本平台提供注册资料，您应承诺您提供的注册资料真实、准确、完整、合法、有效，否则您需承担因此引起的相应责任及后果，且百景公司保留终止您使用本平台各项服务的权利。',
          '3.2您注册本平台账户后，如相应信息发生变更，您必须及时、主动联系百景公司或本平台客户服务人员进行更新。因您未及时更新，造成您不能享受相关服务的、或造成账号及密码泄露等所有责任由您自行承担。',
          '3.3您在本平台进行发布服装面料、辅料信息、销售产品等活动时，涉及您真实姓名/名称、通信地址、联系方式、营业执照等隐私信息的，本平台将予以严格保密，除非得到您授权或法律另有规定，本平台不会向外界披露您隐私信息。除非有下列情况：',
          '(1)有关法律规定或本平台其他规定；',
          '(2)与国家安全、国防安全有关的；',
          '(3)与公共安全、公共卫生、重大公共利益有关的；',
          '(4)与犯罪侦查、起诉、审判和决定书、裁判执行等有关的；',
          '(5)在紧急情况下，为维护您及公权益的；',
          '(6)为维护本平台的商标权、专利权及其他任何合法权益的；',
          '(7)根据您的要求签订合同所必需的；',
          '(8)其他需要公开、编辑或透露个人信息的情况。',
          '3.4您注册成功后，将产生密码等账户信息，您可以根据本平台提示修改您的密码。您应谨慎合理的保存、使用其密码。您若发现任何非法使用您账户或存在安全漏洞的情况，请立即通知本平台。否则，由于您自身的疏忽而导致账户信息泄露等后果，由您自行承担。',
          '3.5您同意，百景公司拥有通过邮件、短信、电话等形式，向在本平台注册、发布信息的您发送订单信息、促销活动等告知信息的权利。如果您不愿意接收此类信息，则您有权主动联系百景公司或本平台客户服务人员进行退订。您理解并同意，对上述的相关促销活动等信息，您应审慎判断其真实性和可靠性，除法律法规明确规定外，您应对依该等信息进行的交易负责。',
          '3.6您若将在本平台注册获得的账户借给他人使用，则必须承担由此产生的全部责任，且实际使用人需承担连带责任。',
          '3.7您同意，百景公司有权使用您的注册信息、密码等信息，登陆进入您的注册账户，进行证据保全，包括但不限于公证、见证、司法协助等。',
          '3.8百景公司有权在您注册及后续经营阶段要求您提供资质证明文件或其他合理所需的文件。请您知悉，如您拒绝提供上述文件，则可能无法正常使用本平台功能，如因此对您权益造成任何损失，由您自行承担。',
          '第4条.账户说明',
          '4.1您应对您的手机号和密码的安全，以及对通过其手机号和密码实施的行为负责。您在本平台注册的手机号和密码仅限于您及您自身内部人员进行使用，不得给予任何第三方使用，否则由此造成的损失由您自行承担，且百景公司保留暂停或终止服务的权利。',
          '4.2除非有法律规定或司法裁定，且征得百景公司的同意，否则，手机号和密码不能以任何方式转让、赠与或继承。如果本平台发现账户的使用者并非账户初始注册人，本平台有权在未经通知的情况下回收该账户且无需向该账户使用人承担法律责任，由此带来的包括并不限于您资料清空等损失由您自行承担。',
          '4.3您遗忘或丢失在本平台注册的密码时，可与本平台客户服务人员取得联系，在提供相关证明资料并经百景公司审核确认后，可找回密码。',
          '4.4本着有效利用本平台账户资源，保障更多合法用户权益之目的，对于恶意注册或者长期（连续超过3个月）未登录的本平台账户，本平台有权回收或冻结账户。',
          '第5条.用户义务',
          '5.1您同意遵守《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》《信息网络传播权保护条例》等有关计算机及互联网规定的法律、法规、规章。在任何情况下，本平台合理地认为您的行为可能违反上述法律、法规，本平台可以在任何时候，不经事先通知有权终止向该您提供服务。本平台欢迎您举报任何违反上述法律或侵犯他人权利的内容，一经发现违法或侵权的内容，本平台将及时删除。',
          '5.2您在使用本平台服务过程中，还必须严格履行以下义务：',
          '(1)不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；',
          '(2)从中国大陆向境外传输资料信息时必须符合中国有关法规；',
          '(3)不得利用本平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；',
          '(4)不得干扰本平台的正常运转，不得侵入本平台及国家计算机信息系统；',
          '(5)不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；',
          '(6)不得教唆他人从事本条款所禁止的行为；',
          '(7)不得发布任何侵犯任何第三方合法权益的内容，包括但不限于第三方的专利权、著作权、商标权、名誉权或其他任何合法权益等；',
          '(8)不得利用在本平台注册的账户进行非法牟利经营活动。',
          '5.3您须对自己在网上的言论和行为承担法律责任。如您在使用网络服务时违反任何上述规定，本平台或其授权的人有权要求您改正或直接采取一切必要的措施（包括但不限于更改或删除您提供的内容、暂停或终止您使用网络服务的权利）以减轻您不当行为造成的影响。',
          '5.4您须对您的合规用工承担法律责任，并承诺将持续坚持合法雇佣，保障员工各项劳动权益，从员工结构、合规雇佣、员工招聘、薪酬管理、员工发展、员工民主、员工健康等各个方面尊重和保障员工权益及员工职业安全健康。您进一步承诺，您已制定涉及招聘、录用和离职等各环节、招聘、晋升、薪酬等各阶段的详细且公正的内部规章制度，在各个环节均已遵从所在国家或地区的相关法律、法规，以平等对待每一位员工，不会因其社会身份进行差异化对待。您已经且将持续采取必要措施，预防非自愿劳动，以员工理解的语言清楚表达与员工签订的合同雇佣条件，确保所有工作纯属自愿，不存在任何通过扣押政府颁发的身份证件等证件或任何惩罚相威胁等方式强迫任何员工从事非其自愿提供的所有工作或服务的情形。',
          '5.5您应不时关注并遵守本平台不时公布或修改的各类合法规则规定。本平台保有删除平台内各类不符合法律政策或不真实的信息内容而无须通知您的权利。若您未遵守以上规定的，本平台有权作出独立判断并采取暂停或关闭您帐号等措施。您须对自己在网上的言论和行为承担法律责任。',
          '第6条.产品信息',
          '6.1您在遵守本平台的规则下，可以在本平台上发布产品的品名、价格、数量、材质、规格等产品销售信息，您应承诺发布的产品信息真实、合法、有效。',
          '6.2采购商可在本平台上发布相关产品的采购信息，服务商可在本平台上获取相关产品的采购信息并根据相关采购信息向您报告订立销售码单的机会，并按照合同达成金额的一定比例计算服务费向您收取。若采购商提供的信息错误导致交易过程中出现利益损失的，则应由采购商而非本平台承担相应法律责任。',
          '6.3本平台上的产品采购需求等信息将根据市场行情及销售情况随时发生变动，本平台不作特别通知。由于本平台产品采购信息需求数量庞大，虽然本平台会尽最大努力保证您所浏览产品信息的准确性，但由于网络及手机终端兼容性等客观原因存在，本平台显示的信息可能会有一定的滞后性或差错，对此情形请您知悉并理解。',
          '6.4您理解并同意，因交易的复杂性和特殊性，服务商收取的服务费和其他相关费用，将因客户、产品、交易时间的不同而不同，具体的服务费用以每张订单成就时产生的账单为准。',
          '6.5为了促进交易的进展，本平台有权向采购商及/或服务商公开您的基本信息、完整的订单信息。在您与服务商签署服务协议，并与采购商签署销售合同后，您有权登录自己的百布账户，在后台系统查看采购商及/或服务商的基本信息、完整的订单信息，包括产品内容、数量、金额、发货或退货流、采购商付款进度、服务收费明细及金额等。',
          '第7条.交易流程',
          '7.1采购商根据自身的需求，在本平台下单或发起询单，服务商获取采购商的订单需求后，将根据采购商要求的商品品名、价格、数量、材质、规格以及对供应商的选择偏好等信息向您报告订立销售码单的机会，并与采购商和您确定商品数量、价格等交易信息。 在您接受服务商向您报告订立销售码单的机会后，本平台将根据采购商的需求信息（包括品名、数量、单价、总价等）自动生成您与服务商的服务订单，以及采购商与您的销售码单，您应认可该销售码单及服务订单对外交易的法律效力。在您通过本平台确认签署销售码单，或您直接从仓库向采购商发出销售码单中的所有货物时（孰早为准）时，即视为您与采购商之间建立了合同关系。在此阶段本平台应根据第6.5条向采购商及/或服务商披露相关信息。 ',
          '7.2在形成销售码单后，采购商将根据销售码单的约定，向您指定的账户支付交易款项。在形成服务订单后，您应当按照服务订单的约定向服务商指定的账户支付服务费。您理解并同意，本平台无需向您开具任何发票。如您需索取服务费对应的发票，请您直接联系服务商开具。 ',
          '7.3您可以根据产品及自身需要，自愿选择接受独立第三方服务商所提供的辅助服务（包括但不限于仓储、产品质量检验、物流配送），您将在使用该等第三方服务前对相应的授权协议/服务协议予以同意确认，以作为您和服务商之间就该等辅助性服务使用所涉及的相关事项的权利义务依据。您理解并同意，本平台不对存货风险、产品的检验结果、配送产品的运输风险等辅助服务内容承担任何责任。 ',
          '7.4您理解并同意，本平台生成的销售码单、服务订单等内容将根据您届时的需求及职能不同而不同，服务订单仅系您与采购商、服务商之间的权利义务依据的参考，本平台不对销售码单、服务订单的内容、履行等承担任何责任，本平台的技术服务费用不因销售码单及/或服务订单的履行问题产生任何减损。',
          '7.5本交易流程为本平台产品交易的参考流程，具体的交易流程将根据服务商届时提供的服务、供应商采用的服务不同而不同，关于本平台交易流程的一切解释权归百景公司所有。',
          '第8条.免责申明',
          '8.1就下列相关事宜的发生，本平台在此声明不承担任何法律责任，如是因您以下行为导致本平台遭受任何损害或者遭受任何来自第三方的纠纷、诉讼、索赔要求等，您须向本平台赔偿相应的损失：',
          '(1)您有违反国家法律法规或本协议的行为；',
          '(2)由于您将用户密码告知他人或与他人共享注册账户，由 此导致的任何个人信息的泄露，或其他方面原因导致的个人信息的泄露；',
          '(3)因黑客攻击、电脑病毒侵入以及因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力因素导致平台服务不能正常运而导致的损失；',
          '(4)在使用本协议下服务的过程中，可能会遇到网络信息或其他用户的行为所带来的风险。',
          '8.2本平台不对任何信息的真实性、适用性、合法性承担责任，也不对除因本平台侵权行为以外给您造成的损害负责。这些风险包括但不限于：',
          '(1)来自他人匿名或冒名的威胁、诽谤；',
          '(2)因使用本协议项下的服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；',
          '(3)因采购商与您之间交易产生的损害；',
          '(4)因服务商与您之间交易产生的损害；',
          '(5)其他因网络信息或您行为引起的风险。',
          '8.3除非另有明确的书面说明，本平台及其所包含的或以其它方式通过本平台提供给您的全部信息、资料、产品（包括软件）和服务，均是在“按现状”和“按现有”的基础上提供的。除非另有明确的书面说明，百景公司不对本平台的运营及其包含在本平台上的信息、资料、产品（包括软件）和服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。如因不可抗力或其它本平台无法控制的原因使本平台销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，百景公司会合理地尽力协助处理善后事宜，但是由此给您造成的损失，百景公司在法律允许的范围内免责。',
          '8.4本平台仅为交易信息发布与对接平台，并非是产品购销行为的参与方，不会对产品发布的信息及交易行为的真实性、合法性、准确性、安全性、及时性、有效性等作任何明示或暗示的保证，亦不承担任何法律责任。若因您与采购商、服务商或其他供应商之间的交易行为（包括但不限于产品数量、质量、物流、货款支付等）引起的任何纠纷，包括但不限于投诉、起诉、交易摩擦、举报及税务争议等，您可以选择提请本平台从中调处或由您自行解决，解决的一切结果与本平台及/或百景公司无关。但当双方的争议已影响本平台的声誉，或争议相对方怠于履行义务时，或本平台认为应当介入时，本平台有权介入您与第三人的争议，依据本平台规则一般人的认知程度对该争议进行判断和处置，您与争议相对方应当予以执行。',
          '第9条.协议更新及用户关注义务',
          '9.1根据国家法律法规变化及平台运营需要，百景公司有权对本协议条款不时地进行修改，修改后的协议一旦被张贴或共识在本平台或百景公司相关平台上即生效，并代替原来的协议。您可随时登陆查阅最新协议；您有义务不时关注并阅读最新版的协议及本平台公告。如您不同意更新后的协议，可以且应立即停止接受百景公司依据本协议提供的服务；如您继续使用本平台提供的服务的，即视为同意更新后的协议。百景公司建议您在使用本平台之前阅读本协议及本平台的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。',
          '9.2任何经百景公司确认已经违反相关法律法规或本协议或本平台使用规则某一项或多项规定的用户，百景公司有权决定是否给予暂停使用或终止使用平台的处理，且因此造成的一切后果由用户自行承担。',
          '第10条.隐私保护',
          '10.1我们非常重视对您的信息的保护，关于您的个人信息将依《隐私政策》受到保护与规范。',
          '第11条.知识产权保护',
          '11.1您理解并知悉，除另有书面声明以外，以下信息和内容的知识产权（包括但不限于专利权、著作权、商标权及商业秘密）归百景公司所有：',
          '(1)在本平台相关服务中所提供的内容和信息（包括但不限于软件、技术、程序、网页、文字、图片、图像、地图、图标、音频、视频、图表、版面设计、电子文档、数据资料等）；',
          '(2)本平台用于提供上述内容和信息的基础设施和平台（包括但不限于软件、网站、应用程序等）；',
          '(3)在本平台提供相关服务中所使用的各项商标、商业形象、商业标识、技术诀窍、标语、文案等；',
          '(4)本平台服务的开发、运营、维护等过程中产生的所有数据和信息。',
          '11.2除非百景公司书面许可，您在使用本平台时不得从事下列任一行为：',
          '(1)删除、编辑或遮挡软件及其副本上关于著作权、商标或其他权利标识或标记的信息；',
          '(2)复制、发布、出售或出租软件或其任何部分；',
          '(3)对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试挖掘、提取软件的源代码；',
          '(4)其他对软件、软件所产生的数据所进行的任何增加、删减、变动的任何行为，包含制作、利用、授权各种第三方外挂、插件、系统进行上述行为。',
          '11.3尊重知识产权是您应尽的义务，如有违反，您需要承担损害赔偿责任。',
          '第12条.法律管辖和适用',
          '12.1本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向广州仲裁委员会申请仲裁。',
          '第13条.用户账户注销',
          '13.1您注销本平台账户的行为，将导致我们终止对您提供本服务，也会给您的售后维权带来诸多不便。注销成功后，我们将删除您的个人信息，使其保持不可被检索、访问的状态，或对其进行匿名化处理。您知晓并理解，依据相关法律法规规定或双方约定，我们仅会在实现法律规定或双方约定目的所必须的最短时间内留存您的相关个人信息。',
          '13.2如果您注销本平台账户，您需要同时满足以下条件：',
          '(1)本平台账户内无资产、无欠款；',
          '(2)本平台账户内无未完成的订单、已发货但未收取货款、未向服务商支付服务费的订单；',
          '(3)本平台账户内无任何纠纷，包括投诉举报或被投诉举报。',
          '13.3在账户注销期间，如果您的账户或服务涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，我们有权自行终止本账户注销而无需另行得到您的同意。',
          '13.4注销本平台账户并不代表本平台账户注销前的操作行为和相关责任得到豁免或减轻。',
          '第14条.协议终止',
          '14.1本协议于以下任一情形下终止：',
          '(1)百景公司及/或本平台有权依据本协议约定，收回、注销用户账户，此情形下，本协议于账户收回、注销之日终止；',
          '(2)在您通过网站自助服务或本平台的客户服务人员注销您的用户账户时，本服务协议于账户注销之日终止。您理解并同意，您已认真阅读、认可本协议及《隐私政策》，并已了解、同意相关用户注销流程及注销后的权利义务安排。',
          '(3)百景公司有权根据自身商业安排经过合理的提前通知终止本平台全部服务，本协议于本平台全部服务依法定程序及方式终止之日终止。',
          '14.2本协议终止后，百景公司将无法继续向您提供任何服务或履行任何其他义务，包括但不限于为您保留或向您披露其原账户中的任何信息，向您或第三方转发任何未曾阅读或发送过的信息等。',
          '14.3本协议的终止不影响第11条的知识产权保护条款以及其他根据其内容应继续有效的条款的有效性，也不影响本协议终止前各方的相关权利和义务，包括但不限于守约方依据本协议向违约方追究相应的违约责任。',
          '第15条.通知与送达',
          '15.1您知悉并认可，百景公司可视情况通过您在注册时提供的联系方式向您通知重要信息。您应当保证所提供的联系方式是准确、有效的，并进行适时更新，如因提供的联系方式不准确或怠于更新等不可归责于百景公司的原因，导致相关通知、文件、文书无法送达或及时送达，您将自行承担由此可能产生的法律后果。',
          '第16条.其 他',
          '16.1本平台所有者是指在政府部门依法许可或备案的本平台经营主体。',
          '16.2本协议中的采购商指通过本平台审核并注册成功的，需通过本平台采购服装面料、辅料产品的用户。',
          '16.3本协议中的服务商指通过本平台审核并注册成功的，需通过本平台获取服装面料、辅料产品的交易信息，撮合采购商及供应商交易达成的用户。',
          '16.4本协议中的供应商指通过本平台审核并注册成功的，需通过本平台销售服装面料、辅料产品的用户。',
          '16.5本协议中的销售码单指本平台根据采购商的最终订单需求，自动生成的供应商与采购商的购销合同。',
          '16.6【销售交易促成服务指服务商通过百布平台获取采购商的服装面料、辅料等采购信息，为供应商寻找服装面料、辅料的潜在采购商，并努力促成供应商与采购商订立货物购销合同。',
          '16.7产品质量检验服务指服务商根据供应商的质量标准要求对产品的颜色、实用幅宽、回后克重、面料数量等进行检验。',
          '16.8保管及物流配送服务指服务商根据供应商的需求，依据采购商的采购信息，暂时保管销售货物，并在供应商指定的期限内，以供应商指定的方式安排产品配送。',
          '16.9信息上传服务指服务商根据供应商的要求，在百布平台及时更新订单的履行状态，包括但不限于上传物流信息和单据、确认发货、确认服务费支付等。',
          '16.10您与百景公司基于交易合作签署的其他书面协议与本协议不一致的，以双方书面签署的协议为准。',
          '16.11为了改善用户体验、完善服务内容，百景公司将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。为了保证本平台的安全性和功能的一致性，百景公司有权不经向您特别通知而对本平台服务进行更新，或者对本平台的部分服务及/或功能效果进行改变或限制。',
          '16.12百景公司尊重您的合法权利，本协议及本平台上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为您提供服务。本平台欢迎您和社会各界提出意见和建议，百景公司将虚心接受并适时修改本协议及本平台上的各类规则。',
          '16.13如您对本协议有任何问题或建议，请在工作时间联系本平台客户服务人员（联系方式：4000680040）。',
          '16.14百景公司对本平台各类的规则具有最终的解释权。',
        ],
      },
      // 服务商
      provider: {
        title: '百布平台服务商用户协议',
        content: [
          '百布平台服务商用户协议（以下简称“本协议”）是您（或称“用户”、“服务商”）与百布（以下简称为“本平台”）所有者广州百景信息科技服务有限公司（以下简称为“百景公司”）之间就本平台服务等相关事宜所订立的协议，请您仔细阅读本协议，特别是涉及免除或责任限制的条款，该等条款可能以加粗的形式提示您注意，您勾选“同意”按钮后，本协议即构成对双方有约束力的法律文件。',
          '第1条.本平台服务条款的确认和接纳',
          '1.1本平台的各项在线服务的所有权和运作权归百景公司所有。您同意本协议所有条款并完成注册程序，才能成为本平台的正式服务商用户。您确认：本协议条款是处理双方权利义务的协议，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。',
          '1.2您点击同意本协议，即视为您确认自己有完全的民事行为能力获取采购商的订单需求，通过本平台撮合布料交易，并享受本平台提供的其他服务，对此您能够独立承担法律责任。',
          '1.3百景公司保留在中华人民共和国大陆地区适用之法律允许的范围内独自决定拒绝服务、关闭您账户、清除或编辑内容或取消订单的权利。',
          '1.4本平台对本协议条款保留最终解释权，并有权在法律允许的范围内对协议条款进行更新，且无须另行通知。修改后的协议条款一旦在本平台上公布即有效并代替原来的协议条款。您选择继续接受本平台提供的服务，则视为您已经接受本协议更新和修改的内容。',
          '第2条.本平台的服务',
          '本平台为信息服务平台，为采购商及供应商提供需求及产品的信息展示服务，并为服务商提供产品智能识别技术及交易信息线索，提高服务商的交易撮合成功率。采购商可以通过本平台即时发布及确认其对于服装面料、辅料的采购需求，平台根据自主研发的色谱识别系统智能筛选对应色卡，并结合百景公司提供的线下服务，明确最终的订单需求；服务商有权通过本平台为采购商及供应商提供销售交易促成服务，即接收采购商的最终订单需求，将该等需求报告给供应商。同时，服务商有权依据供应商通过本平台勾选的服务类型为其提供相应的服务，包括但不限于本协议第17条约定的产品质量检验服务、保管及物流配送服务、信息上传服务等，最终由供应商按照订单需求完成产品的准备、交付等工作。您在完全同意本协议及遵循本平台相关规定的情况下，有权使用本平台的相关服务并支付相应的服务费。本平台所提供的服务不应视为对您和其他相关方本身、交易本身以及其他相关行为提供任何形式的承诺、保证或担保。',
          '第3条.用户信息',
          '3.1您应本着个人或企业诚信向本平台提供注册资料，您应承诺您提供的注册资料真实、准确、完整、合法、有效，否则您需承担因此引起的相应责任及后果，且百景公司保留终止您使用本平台各项服务的权利。',
          '3.2您注册本平台账户后，如相应信息发生变更，您必须及时、主动联系百景公司或本平台客户服务人员进行更新。因您未及时更新，造成您不能享受相关服务的、或造成账号及密码泄露等所有责任由您自行承担。',
          '3.3您在本平台进行交易撮合等活动时，涉及您真实姓名/名称、通信地址、联系方式、营业执照等隐私信息的，本平台将予以严格保密，除非得到您授权或法律另有规定，本平台不会向外界披露您隐私信息。除非有下列情况：',
          '(1)有关法律规定或本平台其他规定；',
          '(2)与国家安全、国防安全有关的；',
          '(3)与公共安全、公共卫生、重大公共利益有关的；',
          '(4)与犯罪侦查、起诉、审判和决定书、裁判执行等有关的；',
          '(5)在紧急情况下，为维护您及公权益的；',
          '(6)为维护本平台的商标权、专利权及其他任何合法权益的；',
          '(7)根据您的要求签订合同所必需的；',
          '(8)其他需要公开、编辑或透露个人信息的情况。',
          '3.4您注册成功后，将产生密码等账户信息，您可以根据本平台提示修改您的密码。您应谨慎合理的保存、使用其密码。您若发现任何非法使用您账户或存在安全漏洞的情况，请立即通知本平台。否则，由于您自身的疏忽而导致账户信息泄露等后果，由您自行承担。',
          '3.5您同意，百景公司拥有通过邮件、短信、电话等形式，向在本平台注册、发布信息的您发送订单信息、促销活动等告知信息的权利。如果您不愿意接收此类信息，则您有权主动联系百景公司或本平台客户服务人员，或按照本平台提供的相应的退订功能进行退订。您理解并同意，对上述的相关促销活动等信息，您应审慎判断其真实性和可靠性，除法律法规明确规定外，您应对依该等信息进行的交易负责。',
          '3.6您若将在本平台注册获得的账户借给他人使用，则必须承担由此产生的全部责任，且实际使用人需承担连带责任。',
          '3.7您同意，百景公司有权使用您的注册信息、密码等信息，登陆进入您的注册账户，进行证据保全，包括但不限于公证、见证、司法协助等。',
          '3.8百景公司有权在您注册及后续经营阶段要求您提供资质证明文件或其他合理所需的文件。请您知悉，如您拒绝提供上述文件，则可能无法正常使用本平台功能，如因此对您权益造成任何损失，由您自行承担。',
          '第4条.账户说明',
          '4.1您应对您的手机号和密码的安全，以及对通过其手机号和密码实施的行为负责。您在本平台注册的手机号和密码仅限于您及您自身内部人员进行使用，不得给予任何第三方使用，否则由此造成的损失由您自行承担，且百景公司保留暂停或终止服务的权利。',
          '4.2除非有法律规定或司法裁定，且征得百景公司的同意，否则，手机号和密码不能以任何方式转让、赠与或继承。如果本平台发现账户的使用者并非账户初始注册人，本平台有权在未经通知的情况下回收该账户且无需向该账户使用人承担法律责任，由此带来的包括并不限于您资料清空等损失由您自行承担。',
          '4.3您遗忘或丢失在本平台注册的密码时，可与本平台客户服务人员取得联系，在提供相关证明资料并经百景公司审核确认后，可找回密码。',
          '4.4本着有效利用本平台账户资源，保障更多合法用户权益之目的，对于恶意注册或者长期（连续超过3个月）未登录的本平台账户，本平台有权回收或冻结账户。',
          '第5条.用户义务 ',
          '5.1您同意遵守《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》《信息网络传播权保护条例》等有关计算机及互联网规定的法律、法规、规章。在任何情况下，本平台合理地认为您的行为可能违反上述法律、法规，本平台可以在任何时候，不经事先通知有权终止向该您提供服务。本平台欢迎您举报任何违反上述法律或侵犯他人权利的内容，一经发现违法或侵权的内容，本平台将及时删除。',
          '5.2您在使用本平台服务过程中，还必须严格履行以下义务：',
          '(1)不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；',
          '(2)从中国大陆向境外传输资料信息时必须符合中国有关法规；',
          '(3)不得利用本平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；',
          '(4)不得干扰本平台的正常运转，不得侵入本平台及国家计算机信息系统；',
          '(5)不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；',
          '(6)不得教唆他人从事本条款所禁止的行为；',
          '(7)不得发布任何侵犯任何第三方合法权益的内容，包括但不限于第三方的专利权、著作权、商标权、名誉权或其他任何合法权益等；',
          '(8)不得利用在本平台注册的账户进行非法牟利经营活动。',
          '5.3您须对自己在网上的言论和行为承担法律责任。如您在使用网络服务时违反任何上述规定，本平台或其授权的人有权要求您改正或直接采取一切必要的措施（包括但不限于更改或删除您提供的内容、暂停或终止您使用网络服务的权利）以减轻您不当行为造成的影响。',
          '5.4您须对您的合规用工承担法律责任，并承诺将持续坚持合法雇佣，保障员工各项劳动权益，从员工结构、合规雇佣、员工招聘、薪酬管理、员工发展、员工民主、员工健康等各个方面尊重和保障员工权益及员工职业安全健康。您进一步承诺，您已制定涉及招聘、录用和离职等各环节、招聘、晋升、薪酬等各阶段的详细且公正的内部规章制度，在各个环节均已遵从所在国家或地区的相关法律、法规，以平等对待每一位员工，不会因其社会身份进行差异化对待。您已经且将持续采取必要措施，预防非自愿劳动，以员工理解的语言清楚表达与员工签订的合同雇佣条件，确保所有工作纯属自愿，不存在任何通过扣押政府颁发的身份证件等证件或任何惩罚相威胁等方式强迫任何员工从事非其自愿提供的所有工作或服务的情形。',
          '5.5您应不时关注并遵守本平台不时公布或修改的各类合法规则规定。本平台保有删除平台内各类不符合法律政策或不真实的信息内容而无须通知您的权利。若您未遵守以上规定的，本平台有权作出独立判断并采取暂停或关闭您帐号等措施。您须对自己在网上的言论和行为承担法律责任。',
          '第6条.产品信息',
          '6.1您在遵守本平台的规则下，可以在本平台上接收采购商的订单需求，包括但不限于产品的品名、价格、数量、材质、规格等产品销售信息以及采购商及供应商的基本信息，包括但不限于联系方式、通讯地址。 ',
          '6.2您可以通过本平台获取采购商的最终订单需求，以快速完成产品交易撮合。在您通过本平台点击确认获取采购商订单需求的全部信息时，本平台将自动生成订单线索，提示您关注产品信息、技术服务费的预估金额等内容。您应当按照本平台的页面提示，确认并支付最终的技术服务费，本平台将根据签署的销售码单金额，按一定比例向您收取服务费。',
          '6.3您理解并同意，因交易的复杂性及特殊性，销售码单的生效时间，以供应商及采购商通过本平台确认销售码单信息的时间，或供应商直接从仓库向采购商发出销售码单中的所有货物的发货时间（孰早为准）。',
          '6.4您理解并同意，本平台向您收取的服务费中包括但不限于您使用的本平台的基础服务费、通过平台智能识别技术及百景小站精确匹配供应商的技术服务费用，以及向您提供采购商订单需求的信息服务费用。若采购商及/或供应商提供的信息错误导致交易过程中出现利益损失的，则应由采购商及/或供应商承担相应法律责任，而非本平台承担。',
          '6.5您理解并同意，本平台上的产品采购需求及产品销售等信息将根据市场行情及销售情况随时发生变动，本平台不作特别通知。由于本平台产品采购信息需求数量庞大，虽然本平台会尽最大努力保证您所浏览产品信息的准确性，但由于网络及手机终端兼容性等客观原因存在，本平台显示的信息可能会有一定的滞后性或差错，对此情形请您知悉并理解。',
          '6.6您理解并同意，为避免程序繁琐，您可以根据本平台的页面提示选择付款方式，按照您选择的付款周期支付当期的技术服务费用，在您向本平台支付技术服务费用后，本平台将在当期最后一天向您开具当期技术服务费用的发票。',
          '6.7您理解并同意，本平台仅系信息提供及发布平台，在销售码单订立完成后，本平台不对销售码单及/或服务订单的履行、售后等事项承担任何责任，本平台的技术服务费用不因销售码单及/或服务订单的履行问题产生任何减损。',
          '第7条.交易流程',
          '7.1采购商根据自身的需求，在本平台下单或发起询单，您获取采购商的订单需求后，将根据采购商要求的商品品名、价格、数量、材质、规格以及对供应商的选择偏好等信息向供应商报告订立销售码单的机会，并与供应商确定商品数量、价格、服务费用等交易信息。在供应商确认接受订立销售码单的机会，或选择需要由您向其提供的服务类型时，本平台上将自动生成供应商与您的服务订单。您理解并同意，本平台生成的服务订单内容将根据您届时提供的服务以及供应商的需求不同而不同，服务协议仅系您与供应商之间的权利义务依据的参考，本平台不对服务订单的内容、履行等承担任何责任。',
          '7.2在您与供应商订立服务订单后，您有权登录自己的百布账户，在后台系统查看完整的订单信息，包括产品内容、数量、金额、发货或退货、采购商付款进度、服务收费明细及金额等。',
          '7.3本交易流程为本平台产品交易的参考流程，具体的交易流程将根据您届时提供的服务、供应商采用的服务不同而不同，关于本平台交易流程的一切解释权归百景公司所有。',
          '第8条.免责申明',
          '8.1就下列相关事宜的发生，本平台在此声明不承担任何法律责任，如是因您以下行为导致本平台遭受任何损害或者遭受任何来自第三方的纠纷、诉讼、索赔要求等，您须向本平台赔偿相应的损失：',
          '(1)您有违反国家法律法规或本协议的行为；',
          '(2)由于您将用户密码告知他人或与他人共享注册账户，由此导致的任何个人信息的泄露，或其他方面原因导致的个人信息的泄露；',
          '(3)因黑客攻击、电脑病毒侵入以及因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力因素导致平台服务不能正常运而导致的损失；',
          '(4)在使用本协议下服务的过程中，可能会遇到网络信息或其他用户的行为所带来的风险。',
          '8.2本平台不对任何信息的真实性、适用性、合法性承担责任，也不对除因本平台侵权行为以外给您造成的损害负责。这些风险包括但不限于：',
          '(1)来自他人匿名或冒名的威胁、诽谤；',
          '(2)因使用本协议项下的服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；',
          '(3)因采购商与您之间交易产生的损害；',
          '(4)因服务商与您之间交易产生的损害；',
          '(5)其他因网络信息或您行为引起的风险。',
          '8.3除非另有明确的书面说明，本平台及其所包含的或以其它方式通过本平台提供给您的全部信息、资料、产品（包括软件）和服务，均是在“按现状”和“按现有”的基础上提供的。除非另有明确的书面说明，百景公司不对本平台的运营及其包含在本平台上的信息、资料、产品（包括软件）和服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。如因不可抗力或其它本平台无法控制的原因使本平台销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，百景公司会合理地尽力协助处理善后事宜，但是由此给您造成的损失，百景公司在法律允许的范围内免责。',
          '8.4本平台仅为交易信息发布与对接平台，并非是产品购销行为的参与方，不会对发布的信息及交易行为的真实性、合法性、准确性、安全性、及时性、有效性等作任何明示或暗示的保证，亦不承担任何法律责任。若因您与采购商、服务商或其他供应商之间的交易行为（包括但不限于产品数量、质量、物流、货款支付等）引起的任何纠纷，包括但不限于投诉、起诉、交易摩擦、举报及税务争议等，您可以选择提请本平台从中调处或由您自行解决，解决的一切结果与本平台及/或百景公司无关。但当双方的争议已影响本平台的声誉，或争议相对方怠于履行义务时，或本平台认为应当介入时，本平台有权介入您与第三人的争议，依据本平台规则及一般人的认知程度对该争议进行判断和处置，您与争议相对方应当予以执行。',
          '第9条.协议更新及用户关注义务',
          '9.1根据国家法律法规变化及平台运营需要，百景公司有权对本协议条款不时地进行修改，修改后的协议一旦被张贴或共识在本平台或百景公司相关平台上即生效，并代替原来的协议。您可随时登陆查阅最新协议；您有义务不时关注并阅读最新版的协议及本平台公告。如您不同意更新后的协议，可以且应立即停止接受百景公司依据本协议提供的服务；如您继续使用本平台提供的服务的，即视为同意更新后的协议。百景公司建议您在使用本平台之前阅读本协议及本平台的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。',
          '9.2任何经百景公司确认已经违反相关法律法规或本协议或本平台使用规则某一项或多项规定的用户，百景公司有权决定是否给予暂停使用或终止使用平台的处理，且因此造成的一切后果由用户自行承担。',
          '第10条.隐私保护',
          '10.1我们非常重视对您的信息的保护，关于您的个人信息将依《隐私政策》受到保护与规范。',
          '第11条.知识产权保护',
          '11.1您理解并知悉，除另有书面声明以外，以下信息和内容的知识产权（包括但不限于专利权、著作权、商标权及商业秘密）归百景公司所有：',
          '(1)在本平台相关服务中所提供的内容和信息（包括但不限于软件、技术、程序、网页、文字、图片、图像、地图、图标、音频、视频、图表、版面设计、电子文档、数据资料等）；',
          '(2)本平台用于提供上述内容和信息的基础设施和平台（包括但不限于软件、网站、应用程序等）；',
          '(3)在本平台提供相关服务中所使用的各项商标、商业形象、商业标识、技术诀窍、标语、文案等；',
          '(4)本平台服务的开发、运营、维护等过程中产生的所有数据和信息。',
          '11.2除非百景公司书面许可，您在使用本平台时不得从事下列任一行为：',
          '(1)删除、编辑或遮挡软件及其副本上关于著作权、商标或其他权利标识或标记的信息；',
          '(2)复制、发布、出售或出租软件或其任何部分；',
          '(3)对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试挖掘、提取软件的源代码；',
          '(4)其他对软件、软件所产生的数据所进行的任何增加、删减、变动的任何行为，包含制作、利用、授权各种第三方外挂、插件、系统进行上述行为。',
          '11.3尊重知识产权是您应尽的义务，如有违反，您需要承担损害赔偿责任。',
          '第12条.法律管辖和适用',
          '12.1本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向广州仲裁委员会申请仲裁。',
          '第13条.用户账户注销',
          '13.1您注销本平台账户的行为，将导致我们终止对您提供本服务，也会给您的售后维权带来诸多不便。注销成功后，我们将删除您的个人信息，使其保持不可被检索、访问的状态，或对其进行匿名化处理。您知晓并理解，依据相关法律法规规定或双方约定，我们仅会在实现法律规定或双方约定目的所必须的最短时间内留存您的相关个人信息。',
          '13.2如果您注销本平台账户，您需要同时满足以下条件：',
          '(1)本平台账户内无资产、无欠款；',
          '(2)本平台账户内无未完成的订单、已发货但未收取货款、未向服务商支付服务费的订单；',
          '(3)本平台账户内无任何纠纷，包括投诉举报或被投诉举报。',
          '13.3在账户注销期间，如果您的账户或服务涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，我们有权自行终止本账户注销而无需另行得到您的同意。',
          '13.4注销本平台账户并不代表本平台账户注销前的操作行为和相关责任得到豁免或减轻。',
          '第14条.协议终止',
          '14.1本协议于以下任一情形下终止：',
          '(1)百景公司及/或本平台有权依据本协议约定，收回、注销用户账户，此情形下，本协议于账户收回、注销之日终止；',
          '(2)在您通过网站自助服务或本平台的客户服务人员注销您的用户账户时，本服务协议于账户注销之日终止。您理解并同意，您已认真阅读、认可本协议及《隐私政策》，并已了解、同意相关用户注销流程及注销后的权利义务安排。',
          '(3)百景公司有权根据自身商业安排经过合理的提前通知终止本平台全部服务，本协议于本平台全部服务依法定程序及方式终止之日终止。',
          '14.2本协议终止后，百景公司将无法继续向您提供任何服务或履行任何其他义务，包括但不限于为您保留或向您披露其原账户中的任何信息，向您或第三方转发任何未曾阅读或发送过的信息等。',
          '14.3本协议的终止不影响第11条的知识产权保护条款以及其他根据其内容应继续有效的条款的有效性，也不影响本协议终止前各方的相关权利和义务，包括但不限于守约方依据本协议向违约方追究相应的违约责任。',
          '第15条.通知与送达',
          '15.1您知悉并认可，百景公司可视情况通过您在注册时提供的联系方式向您通知重要信息。您应当保证所提供的联系方式是准确、有效的，并进行适时更新，如因提供的联系方式不准确或怠于更新等不可归责于百景公司的原因，导致相关通知、文件、文书无法送达或及时送达，您将自行承担由此可能产生的法律后果。',
          '第16条.其 他',
          '16.1本平台所有者是指在政府部门依法许可或备案的本平台经营主体。',
          '16.2本协议中的采购商指通过本平台审核并注册成功的，需通过本平台采购服装面料、辅料产品的用户。',
          '16.3本协议中的服务商指通过本平台审核并注册成功的，需通过本平台获取服装面料、辅料产品的交易信息，撮合采购商及供应商交易达成的用户。',
          '16.4本协议中的供应商指通过本平台审核并注册成功的，需通过本平台销售服装面料、辅料产品的用户。',
          '16.5本协议中的销售码单指本平台根据采购商的最终订单需求，自动生成的供应商与采购商的购销合同。',
          '16.6销售交易促成服务指服务商通过百布平台获取采购商的服装面料、辅料等采购信息，为供应商寻找服装面料、辅料的潜在采购商，并努力促成供应商与采购商订立货物购销合同。',
          '16.7产品质量检验服务指服务商根据供应商的质量标准要求对产品的颜色、实用幅宽、回后克重、面料数量等进行检验。',
          '16.8保管及物流配送服务指服务商根据供应商的需求，依据采购商的采购信息，暂时保管销售货物，并在供应商指定的期限内，以供应商指定的方式安排产品配送。',
          '16.9信息上传服务指服务商根据供应商的要求，在百布平台及时更新订单的履行状态，包括但不限于上传物流信息和单据、确认发货、确认服务费支付等。',
          '16.10您与百景公司基于交易合作签署的其他书面协议与本协议不一致的，以双方书面签署的协议为准。',
          '16.11为了改善用户体验、完善服务内容，百景公司将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。为了保证本平台的安全性和功能的一致性，百景公司有权不经向您特别通知而对本平台服务进行更新，或者对本平台的部分服务及/或功能效果进行改变或限制。',
          '16.12百景公司尊重您的合法权利，本协议及本平台上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为您提供服务。本平台欢迎您和社会各界提出意见和建议，百景公司将虚心接受并适时修改本协议及本平台上的各类规则。',
          '16.13如您对本协议有任何问题或建议，请在工作时间联系本平台客户服务人员（联系方式：4000680040）。',
          '16.14百景公司对本平台各类的规则具有最终的解释权。',
        ],
      },
      // 采购商
      purchaser: {
        title: '百布平台采购商用户服务协议',
        content: [
          '百布平台采购商用户服务协议（以下简称“本协议”）是您（或称“用户”、“采购商”）与百布（以下简称“本平台”）所有者广州百景信息科技服务有限公司（以下简称为“百景公司”）之间就本平台服务等相关事宜所订立的协议，请您仔细阅读本协议，特别是涉及免除或责任限制的条款，该等条款可能以加粗的形式提示您注意，您勾选“同意”按钮后，本协议即构成对双方有约束力的法律文件。',
          '第1条.平台服务条款的确认和接纳',
          '1.1本平台的各项在线服务的所有权和运作权归百景公司所有。您同意本协议所有条款并完成注册程序，才能成为本平台的正式采购商用户。您确认：本协议条款是处理双方权利义务的协议，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。',
          '1.2您点击同意本协议，即视为您确认自己具有完全的民事行为能力在线购买服装面料、辅料及享受本平台提供的其他服务，对此您能够独立承担法律责任。',
          '1.3百景公司保留在中华人民共和国大陆地区适用之法律允许的范围内独自决定拒绝服务、关闭您账户、清除或编辑内容或取消订单的权利。',
          '1.4本平台对本协议条款保留最终解释权，并有权在法律允许的范围内对协议条款进行更新，且无须另行通知。修改后的协议条款一旦在本平台上公布即有效并代替原来的协议条款。您选择继续接受本平台提供的服务，则视为您已经接受本协议更新和修改的内容。',
          '第2条.本平台的服务',
          '2.1本平台为信息服务平台，为采购商及供应商提供需求及产品的信息展示服务，并为服务商提供产品需求智能识别技术及交易信息线索，提高服务商的交易撮合成功率。采购商可以通过本平台即时发布及确认其对于服装面料、辅料的采购需求，平台根据自主研发的色谱识别系统智能筛选对应色卡，并结合百景公司提供的线下匹配服务，明确采购商的最终订单需求；服务商有权通过本平台为采购商及供应商提供销售交易促成服务，即接收采购商的最终订单需求，将该等需求报告给供应商。同时，服务商有权依据供应商通过本平台勾选的服务类型为其提供相应的服务，包括但不限于本协议第17条约定的产品质量检验服务、保管及物流配送服务、信息上传服务等，最终由供应商按照订单需求完成产品的准备、交付等工作。',
          '2.2您在完全同意本协议及遵循本平台相关规定的情况下，有权使用本平台的相关服务。本平台所提供的服务不应视为对您和其他相关方本身、交易本身以及其他相关行为提供任何形式的承诺、保证或担保。',
          '第3条.用户信息',
          '3.1您应本着个人或企业诚信向本平台提供注册资料，您应承诺您提供的注册资料真实、准确、完整、合法、有效，否则您需承担因此引起的相应责任及后果，且百景公司保留终止您使用本平台各项服务的权利。',
          '3.2您注册本平台账户后，如相应信息发生变更，您必须及时、主动联系百景公司或本平台客户服务人员进行更新。因您未及时更新，造成您不能享受相关服务的、或造成账号及密码泄露等所有责任由您自行承担。',
          '3.3您在本平台进行浏览、下单订货等活动时，涉及您真实姓名/名称、通信地址、联系方式、营业执照等隐私信息的，本平台将予以严格保密，除非得到您授权或法律另有规定，本平台不会向外界披露用户隐私信息。除非有下列情况：',
          '(1)有关法律规定或本平台相关规定；',
          '(2)与国家安全、国防安全有关的；',
          '(3)与公共安全、公共卫生、重大公共利益有关的；',
          '(4)与犯罪侦查、起诉、审判和决定书、裁判执行等有关的；',
          '(5)在紧急情况下，为维护您及公众权益的；',
          '(6)为维护本平台的商标权、专利权及其他任何合法权益的；',
          '(7)根据您的要求签订合同所必需的；',
          '(8)其他需要公开、编辑或透露个人信息的情况。',
          '3.4您注册成功后，将产生密码等账户信息，您可以根据本平台提示修改您的密码。您应谨慎合理地保存、使用其密码。您若发现任何非法使用您账户或存在安全漏洞的情况，请立即通知本平台。否则，由于您自身的疏忽而导致账户信息泄露等后果，由您自行承担。',
          '3.5您同意，百景公司拥有通过邮件、短信、电话等形式，向在本平台注册、下单订货的您发送订单信息、促销活动等告知信息的权利。如果您不愿意接收此类信息，则您有权主动联系百景公司或本平台客户服务人员进行退订。您理解并同意，对上述的相关促销活动等信息，您应审慎判断其真实性和可靠性，除法律法规明确规定外，您应对依该等信息进行的交易负责。',
          '3.6您若将在本平台注册获得的账户借给他人使用，则必须承担由此产生的全部责任，且实际使用人需承担连带责任。',
          '3.7您同意，百景公司有权使用用户的注册信息、密码等信息，登陆进入您的注册账户，进行证据保全，包括但不限于公证、见证、司法协助等。',
          '3.8百景公司有权在您注册及后续经营阶段要求您提供资质证明文件或其他合理所需的文件。请您知悉，如您拒绝提供上述文件，则可能无法正常使用本平台功能，如因此对您权益造成任何损失，由您自行承担。',
          '第4条.账户说明',
          '4.1您应对您的手机号和密码的安全，以及对通过其手机号和密码实施的行为负责。您在本平台注册的手机号和密码仅限于您及您自身内部人员进行使用，不得给予任何第三方使用，否则由此造成的损失由您自行承担，且百景公司保留暂停或终止服务的权利。',
          '4.2除非有法律规定或司法裁定，且征得百景公司的同意，否则，手机号和密码不能以任何方式转让、赠与或继承。如果本平台发现账户的使用者并非账户初始注册人，本平台有权在未经通知的情况下回收该账户且无需向该账户使用人承担法律责任，由此带来的包括并不限于您资料清空等损失由您自行承担。',
          '4.3您遗忘或丢失在本平台注册的密码时，可与本平台客户服务人员取得联系，在提供相关证明资料并经百景公司审核确认后，可找回密码。',
          '4.4本着有效利用本平台账户资源，保障更多合法用户权益之目的，对于恶意注册或者长期（连续超过 3 个月）未登录的本平台账户，本平台有权回收或冻结账户。',
          '第5条.用户依法言行义务',
          '5.1您同意遵守《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《信息网络传播权保护条例》等有关计算机及互联网规定的法律、法规、规章。在任何情况下，本平台合理地认为您的行为可能违反上述法律、法规，本平台可以在任何时候，不经事先通知有权终止向该您提供服务。本平台欢迎您举报任何违反上述法律或侵权的内容，一经发现违法或侵权的内容，本平台将及时删除。',
          '5.2您在使用本平台服务过程中，还必须严格履行以下义务：',
          '(1)不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；',
          '(2)从中国大陆向境外传输资料信息时必须符合中国有关法规；',
          '(3)不得利用本平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；',
          '(4)不得干扰本平台的正常运转，不得侵入本平台及国家计算机信息系统；',
          '(5)不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；',
          '(6)不得教唆他人从事本条款所禁止的行为；',
          '(7)不得发布任何侵犯任何第三方合法权益的内容，包括但不限于第三方的专利权、著作权、商标权、名誉权或其他任何合法权益等；',
          '(8)不得利用在本平台注册的账户进行非法牟利经营活动；',
          '5.3您须对自己在网上的言论和行为承担法律责任。如您在使用网络服务时违反任何上述规定，本平台或其授权的人有权要求您改正或直接采取一切必要的措施（包括但不限于更改或删除您发表的内容、暂停或终止用户使用网络服务的权利）以减轻您不当行为造成的影响。',
          '5.4您应不时关注并遵守本平台不时公布或修改的各类合法规则规定。本平台保有删除平台内各类不符合法律政策或不真实的信息内容而无须通知您的权利。若您未遵守以上规定的，本平台有权作出独立判断并采取暂停或关闭您账户等措施。您须对自己在网上的言论和行为承担法律责任。',
          '第6条.产品信息',
          '6.1本平台上的产品价格、数量、是否有货等产品信息将根据市场行情及采购情况随时发生变动，本平台不作特别通知。由于本平台产品销售信息数量庞大，虽然本平台会尽最大努力保证您所浏览产品信息的准确性，但由于网络及手机终端兼容性等客观原因存在，本平台显示的信息可能会有一定的滞后性或差错，对此情形请您知悉并理解。',
          '第7条.下单订货',
          '7.1您在本平台下订单时，请您仔细确认所订购产品的品名、价格、数量、材质、规格、联系地址、电话、收货人、收货地址等信息。若您提供的信息错误导致交易过程中出现利益损失的，则百景公司将不承担相应法律责任或其他任何责任。您可以选择在本平台自主下订单，也可以选择委托本平台的业务人员代您下订单，业务人员代您下订单成就时，本平台会通过短信或您与本平台约定的联系方式通知您订单的详细信息，包括但不限于您所采购产品的品名、价格、数量、材质、规格等。为了保障您的合法权益，您应当在收到代为下单的通知信息后，及时以短信、扫码、小程序或其他书面形式确认订单详细信息，如服务商提供的订单信息有误，请您及时联系业务人员更正订单信息，如您在通知信息发出后的十二个小时内未对订单信息提出异议，视为您已同意订单信息，则该业务人员的行为和意思表示产生的法律后果均由您承担。',
          '7.2您应在下单后在本平台规定的时限内向供应商指定的银行账户支付交易款项。为了保障用户的合法权益，避免交易风险，您在付款前，请仔细核对付款信息。',
          '7.3除法律另有强制性规定外，各方约定如下：本平台展示的产品的品名、价格、数量、材质、规格等信息仅是供应商的要约邀请，您线上或线下下订单时须确定您希望购买的产品数量、材质、规格、收货方式等内容。',
          '7.4您理解并同意，服务商及/或供应商可以通过本平台获得您在本平台发出及/或确认的最终订单需求，系统将根据您在本平台发布及/或确认的产品的品名、价格、数量、材质、规则、收货方式等内容自动生成您与供应商的销售码单，在您与供应商通过本平台共同确认签署销售码单，或供应商直接从仓库向您发出销售码单中的所有货物时（孰早为准），即视为您与供应商之间建立了合同关系。',
          '7.5您理解并同意，本平台生成的销售码单内容将根据您届时发布的订单需求不同而不同，销售码单仅系您与供应商之间的权利义务依据的参考，本平台不对销售码单的内容、履行等承担任何责任。',
          '7.6由于市场变化及各种以合理商业努力难以控制的因素的影响，本平台无法保证您提交的订单信息中希望购买的产品都有货；如您拟购买的产品发生缺货，您有权取消订单，平台不承担任何责任。',
          '7.7您所支付的交易款项包括您向供应商支付的购买产品的货款。本平台对于您与供应商之间关于货款的纠纷不承担任何法律责任。如您需要索取商品对应的销售发票，请您联系供应商提供，本平台无需向您开具任何发票。',
          '第8条.收货',
          '8.1根据您和供应商的具体约定，采取以下方式收取产品：',
          '(1)服务商或供应商直接运送产品至您指定地点；',
          '(2)您自行至供应商指定地点提取产品。',
          '8.2您理解并同意，您应当在您已收到服务商或供应商运送的产品，或您已自行提取产品之日在本平台确认收货，如您在供应商及/或服务商在本平台上传物流配送之日起【七日内】，或在销售码单约定的自提时间之日起【三日内】未确认收货，或未在前述期限内确认延迟收货，本平台将自动确认收货。',
          '8.3因如下情况造成无法收货等，百景公司、供应商及服务商不承担任何责任：',
          '(1)您提供的收货信息错误导致的；',
          '(2)情势变更因素导致的；',
          '(3)不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。',
          '第9条.免责申明',
          '9.1就下列相关事宜的发生，本平台在此声明不承担任何法律责任，如是因您以下行为导致本平台遭受任何损害或者遭受任何来自第三方的纠纷、诉讼、索赔要求等，您须向本平台赔偿相应的损失：',
          '(1)您有违反国家法律法规或本协议的行为；',
          '(2)您将用户密码告知他人或与他人共享注册账户，由此导致的任何个人信息的泄露，或其他方面原因导致的个人信息的泄露；',
          '(3)因黑客攻击、电脑病毒侵入以及因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力因素导致平台服务不能正常运而导致的损失；',
          '(4)在使用本协议下服务的过程中，可能会遇到网络信息或其他用户的行为所带来的风险。',
          '9.2本平台不对任何信息的真实性、适用性、合法性承担责任，也不对除因本平台侵权行为以外给您造成的损害负责。这些风险包括但不限于：',
          '(1)来自他人匿名或冒名的威胁、诽谤；',
          '(2)因使用本协议项下的服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；',
          '(3)因供应商与您之间交易产生的损害；',
          '(4)因服务商与您之间交易产生的损害；',
          '(5)其他因网络信息或您行为引起的风险。',
          '9.3除非另有明确的书面说明，本平台及其所包含的或以其它方式通过本平台提供给您的全部信息、资料、产品（包括软件）和服务，均是在“按现状”和“按现有”的基础上提供的。除非另有明确的书面说明，百景公司不对本平台的运营及其包含在本平台上的信息、资料、产品（包括软件）和服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。如因不可抗力或其它本平台无法控制的原因使本平台销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，百景公司会合理地尽力协助处理善后事宜。',
          '9.4本平台仅为交易信息发布平台，并非是产品购销行为的参与方，不会对供应商发布的产品信息及交易行为的真实性、合法性、准确性、安全性、及时性、有效性等作任何明示或暗示的保证，亦不承担任何法律责任。若因您与供应商之间的交易行为（包括但不限于产品数量、质量、物流、货款支付等）引起的任何纠纷，包括但不限于投诉、起诉、交易摩擦、举报及税赋等，您可以选择提请本平台从中调处或由您自行解决，解决的一切结果与本平台及/或百景公司无关。但当双方的争议已影响本平台的声誉，或争议相对方怠于履行义务时，或本平台认为应当介入时，本平台有权介入您与第三人的争议，依据本平台规则及一般人的认知程度对该争议进行判断和处置，您与争议相对方应当予以执行。',
          '第10条.隐私保护',
          '10.1我们非常重视对您的信息的保护，关于您的个人信息将依《隐私政策》受到保护与规范。',
          '第11条.知识产权保护 ',
          '11.1您理解并知悉，除另有书面声明以外，以下信息和内容的知识产权（包括但不限于专利权、著作权、商标权及商业秘密）归百景公司所有：',
          '(1)在本平台相关服务中所提供的内容和信息（包括但不限于软件、技术、程序、网页、文字、图片、图像、地图、图标、音频、视频、图表、版面设计、电子文档、数据资料等）；',
          '(2)本平台用于提供上述内容和信息的基础设施和平台（包括但不限于软件、网站、应用程序等）；',
          '(3)在本平台提供相关服务中所使用的各项商标、商业形象、商业标识、技术诀窍、标语、文案等；',
          '(4)本平台服务的开发、运营、维护等过程中产生的所有数据和信息。',
          '11.2除非百景公司书面许可，您在使用本平台时不得从事下列任一行为：',
          '(1)删除、编辑或遮挡软件及其副本上关于著作权、商标或其他权利标识或标记的信息；',
          '(2)复制、发布、出售或出租软件或其任何部分；',
          '(3)对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试挖掘、提取软件的源代码；',
          '(4)其他对软件、软件所产生的数据所进行的任何增加、删减、变动的任何行为，包含制作、利用、授权各种第三方外挂、插件、系统进行上述行为。',
          '11.3尊重知识产权是您应尽的义务，如有违反，您需要承担损害赔偿责任。',
          '第12条.协议更新及用户关注义务',
          '12.1根据国家法律法规变化及平台运营需要，百景公司有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本平台或百景公司相关平台上即生效，并代替原来的协议。您可随时登陆查阅最新协议；您有义务不时关注并阅读最新版的协议及本平台公告。如您不同意更新后的协议，可以且应立即停止接受百景公司依据本协议提供的服务；如您继续使用本平台提供的服务的，即视为同意更新后的协议。百景公司建议您在使用本平台之前阅读本协议及本平台的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。',
          '12.2任何经百景公司确认已经违反相关法律法规或本协议或本平台使用规则某一项或多项规定的用户，百景公司有权决定是否给予暂停使用或终止使用平台的处理，且因此造成的一切后果由用户自行承担。',
          '第13条.法律管辖和适用',
          '13.1本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向广州仲裁委员会申请仲裁。',
          '第14条.用户账户注销',
          '14.1您注销本平台账户的行为，将导致我们终止对您提供本服务，也会给您的售后维权带来诸多不便。注销成功后，我们将删除您的个人信息，使其保持不可被检索、访问的状态，或对其进行匿名化处理。您知晓并理解，依据相关法律法规规定或双方约定，我们仅会在实现法律规定或双方约定目的所必须的最短时间内留存您的相关个人信息。',
          '14.2如果您注销本平台账户，您需要同时满足以下条件：',
          '(1)本平台账户内无资产、无欠款；',
          '(2)本平台账户内无未完成的订单、已采购商品但未支付货款的订单；',
          '(3)本平台账户内无任何纠纷，包括投诉举报或被投诉举报。',
          '14.3在账户注销期间，如果您的账户或服务涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，我们有权自行终止本账户注销而无需另行得到您的同意。',
          '14.4注销本平台账户并不代表本平台账户注销前的操作行为和相关责任得到豁免或减轻。',
          '第15条.协议终止',
          '15.1本协议于以下任一情形下终止：',
          '(1)百景公司及/或本平台有权依据本协议约定，收回、注销用户账户，此情形下，本协议于账户收回、注销之日终止；',
          '(2)在您通过网站自助服务或本平台的客户服务人员注销您的用户账户时，本服务协议于账户注销之日终止。您理解并同意，您已认真阅读、认可本协议及《隐私政策》，并已了解、同意相关用户注销流程及注销后的权利义务安排；',
          '(3)百景公司有权根据自身商业安排经过合理的提前通知终止本平台全部服务，本协议于本平台全部服务依法定程序及方式终止之日终止。',
          '15.2本协议终止后，百景公司将无法继续向您提供任何服务或履行任何其他义务，包括但不限于为您保留或向您披露其原账户中的任何信息，向您或第三方转发任何未曾阅读或发送过的信息等。',
          '15.3本协议的终止不影响第11条的知识产权保护条款以及其他根据其内容应继续有效的条款的有效性，也不影响本协议终止前各方的相关权利和义务，包括但不限于守约方依据本协议向违约方追究相应的违约责任。',
          '第16条.通知与送达',
          '16.1您知悉并认可，百景公司可视情况通过您在注册时提供的联系方式向您通知重要信息。您应当保证所提供的联系方式是准确、有效的，并进行适时更新，如因提供的联系方式不准确或怠于更新等不可归责于百景公司的原因，导致相关通知、文件、文书无法送达或及时送达，您将自行承担由此可能产生的法律后果。',
          '第17条.其他',
          '17.1本平台所有者是指在政府部门依法许可或备案的本平台经营主体。',
          '17.2本协议中的采购商指通过本平台审核并注册成功的，需通过本平台采购服装面料、辅料产品的用户。',
          '17.3本协议中的服务商指通过本平台审核并注册成功的，需通过本平台获取服装面料、辅料产品的交易信息，撮合采购商及供应商交易达成的用户。',
          '17.4本协议中的供应商指通过本平台审核并注册成功的，需通过本平台销售服装面料、辅料产品的用户。',
          '17.5本协议中的销售码单指本平台根据采购商的最终订单需求，自动生成的供应商与采购商的购销合同。',
          '17.6销售交易促成服务指服务商通过百布平台获取采购商的服装面料、辅料等采购信息，为供应商寻找服装面料、辅料的潜在采购商，并努力促成供应商与采购商订立货物购销合同。',
          '17.7产品质量检验服务指服务商根据供应商的质量标准要求对产品的颜色、实用幅宽、回后克重、面料数量等进行检验。',
          '17.8保管及物流配送服务指服务商根据供应商的需求，依据采购商的采购信息，暂时保管销售货物，并在供应商指定的期限内，以供应商指定的方式安排产品配送。',
          '17.9信息上传服务指服务商根据供应商的要求，在百布平台及时更新订单的履行状态，包括但不限于上传物流信息和单据、确认发货、确认服务费支付。',
          '17.10您与百景公司基于交易合作签署的其他书面协议与本协议不一致的，以双方书面签署的协议为准。',
          '17.11为了改善用户体验、完善服务内容，百景公司将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。为了保证本平台的安全性和功能的一致性，百景公司有权不经向您特别通知而对本平台服务进行更新，或者对本平台的部分服务及/或功能效果进行改变或限制。',
          '17.12百景公司尊重您的合法权利，本协议及本平台上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为您提供服务。本平台欢迎用户和社会各界提出意见和建议，百景公司将虚心接受并适时修改本协议及本平台上的各类规则。',
          '17.13如您对本协议有任何问题或建议，请在工作时间联系本平台客户服务人员（联系方式：【4000680040】）。',
          '17.14百景公司对本平台各类的规则具有最终的解释权。',
        ],
      },
      type: '',
      isMobile: false,
    };
  },

  created() {
    this.isShowSubmit = !this.$route.query.readonly;
    // document.title = '注册协议';
  },

  mounted() {
    this.type = this.$route.params.type;
    this.data.title = this[this.$route.params.type].title;
    this.data.content = this[this.$route.params.type].content;
    document.title = this[this.$route.params.type].title;
    if (this.isShowSubmit) {
      this.timeout();
    }
    this.getIsMobile();
  },

  computed: {},

  components: {},

  methods: {
    getIsMobile() {
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      console.log(this.isMobile, 'isMobile');
    },
    submit() {
      // html快照
      try {
        console.log(this.$refs.agreementContent.innerHTML);
        if (window.__wxjs_environment === 'miniprogram') {
          // 微信小程序的环境下
          wx.miniProgram.postMessage({
            data: {
              signContext: encodeURIComponent(this.$refs.agreementContent.innerHTML),
              // 刚才拿到的base64 数据
            },
          });

          wx.miniProgram.navigateBack({ delta: 1 });
        } else {
          const {
            type,
          } = this.$route.params;
          const {
            usingRouteBack,
          } = this.$route.query;

          localStorage
            .setItem(
              `${type}AccountInfo_signContext`,
              encodeURIComponent(this.$refs.agreementContent.innerHTML),
            );
          // window.history.go(-1);
          if (usingRouteBack) {
            this.$router.go(-1);
            return;
          }
          this.$router.replace({
            path: `/baibu/${type}/register`,
            query: this.$route.query,
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    timeout() {
      this.submitTimeout = setTimeout(() => {
        this.submitCount -= 1;
        if (this.submitCount) {
          this.timeout();
        }
      }, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
.agreement-con {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  padding-bottom: 80px;
  color: #000000;
  background: #f8f8f8;
  overflow-y: auto;
  .date {
    text-align: right;
    margin-right: -10px;
    font-size: 0.15rem;
  }
  h1 {
    margin-top: 15px;
  }
}
.layout-agreement {
  min-height: 100%;
  padding: 0 20px 20px 20px;
  font-size: 14px;
  background: #ffffff;
  margin: 15px;
  border: 1px solid #ffffff;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  box-sizing: border-box;
}
.agreement-title {
  font-size: 20px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  margin: 25px 0;
  text-align: left;
}
p.agreement-item {
  min-height: 24px;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
  text-indent: 28px;
}
.agreement-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  padding: 20px;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 -8px 16px 0 rgba(0, 0, 0, 0.06);
}
.agreement-btn {
  border: 0;
  border-radius: 5px;
  background: #409eff;
  color: #fff;
  width: 100%;
  outline: none;
  font-size: 16px;
  height: 40px;
  line-height: 40px;
  &:active {
    opacity: .8;
  }
  &[disabled] {
    background: #d7d7d7;
    color: #333;
  }
}
.pc-layout-agreement {
  h1 {
    text-align: center;
    font-weight: 800;
    font-size: 18px;
    margin: 10px 0;
  }
  padding: 0 20% 10px 20%;
  p.agreement-item {
    font-size: 0.13rem;
    line-height: 0.18rem;
    min-height: max-content;
  }
}
.pc-agreement-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  padding:10px 0;
  height: 20px;
  font-size: 0.2rem;
}
.pc-agreement-footer {
  padding: 5px 0;
}
.pc-agreement-con {
  padding-bottom: 30px;
}
</style>
